<template>
   <div class="componet-slide-funcionarios">
      <div class="anterior">
         <i
            class="pi pi-chevron-left"
            style="font-size: 2rem; color: darkblue"
            @click="this.anterior()"
            :class="{ naoPossuiProxima: !this.possuiPaginaAnterior }"
         ></i>
      </div>

      <div class="dados">
         <ProgressSpinner strokeWidth="5" animationDuration="1" v-if="this.loading" class="p-progress-spinner" />
         <template v-if="!this.loading">
            <div class="" style="display: flex">
               <div style="display: flex; align-items: center">
                  <img src="https://i.im.ge/2022/09/15/1lQxOc.calendario.jpg" alt="" style="max-width: 80px; border-radius: 45px" />
               </div>
               <div
                  style="display: flex; align-items: center; width: 100%; float: left; padding-left: 15px"
                  v-for="(item, index) in this.items"
                  :key="index"
               >
                  <div>
                     Período:
                     <span class="descricao nome">{{ this.viewFormatDateTime(item.dataInicio) }} </span>
                  </div>
                  <div>
                     &nbsp;&nbsp;até:
                     <span class="descricao nome">{{ this.viewFormatDateTime(item.dataFim) }}</span>
                  </div>
               </div>
            </div>
         </template>
      </div>
      <div class="proximo">
         <i class="pi pi-chevron-right" style="font-size: 2rem" @click="this.proximo()" :class="{ naoPossuiProxima: !this.possuiProximaPagina }"></i>
      </div>
   </div>
</template>
<script src="./slide-referencias.js"></script>
